import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Badge,
  Modal,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
} from "@mui/material";
import { Notifications } from "@mui/icons-material";
import useCurrentUserData from "../hooks/useCurrentUserData";
import { renderLooseNode } from "../utils/rewards";
import { dashboardPalette } from "../theme";
import { UpdateEntryNotifications } from "../firebase-config";

interface NavbarProps {
  title: string;
}

const Navbar: React.FC<NavbarProps> = ({ title }) => {
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const { userData } = useCurrentUserData();
  const notifications = userData?.Notifications ?? [];
  const unreadNotifications = notifications.filter(
    (notification) => !notification.Checked,
  );

  function GetNotif() {
    return unreadNotifications.length;
  }
  console.log("test")
  function ChangeNotif(e: boolean) {
    if (e) {
      setNotificationsOpen(true)
    }
    if (!e) {
      setNotificationsOpen(false)

      const updatedNotifications = notifications.map((not: any) => {
        if (not.Checked === false) {
          not.Checked = true
        }
        return not
      })
      if (updatedNotifications.length > 0) {
        UpdateEntryNotifications(userData?.id!, updatedNotifications)
      }
    }
  }

  /** 
  const notifications = [
    {
      id: 1,
      type: "success",
      title: "¡Misión completada!",
      message: "Has ganado 50 XP",
      icon: CheckCircle,
      color: "#4caf50",
    },
    {
      id: 2,
      type: "info",
      title: "Nueva actualización",
      message: "Funciones de avatar disponibles",
      icon: Info,
      color: "#2196f3",
    },
    {
      id: 3,
      type: "warning",
      title: "Skill pendiente",
      message: "Completa tu evaluación de JavaScript",
      icon: Warning,
      color: "#ff9800",
    },
  ];
*/
  return (
    <AppBar
      position="static"
      sx={{
        background: "linear-gradient(135deg, #e8dff5, #dbd6e8)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", padding: "8px 24px" }}>
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "#333",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            onClick={() => ChangeNotif(true)}
            sx={{
              color: "var(--dashboard-header-blue)",
              background: "rgba(255, 255, 255, 0.42)",
              border: `2px solid ${dashboardPalette.panelBorder}`,
              "&:hover": {
                background: "rgba(255, 255, 255, 0.62)",
                transform: "scale(1.05)",
              },
              transition: "all 0.2s ease",
            }}
          >
            {notifications.length > 0 ? (
              <Badge badgeContent={GetNotif()} color="error">
                <Notifications />
              </Badge>
            ) : (
              <Notifications />
            )}
          </IconButton>
        </Box>
      </Toolbar>

      <Modal
        open={notificationsOpen}
        onClose={() => ChangeNotif(false)}
        aria-labelledby="notifications-modal"
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(47, 43, 116, 0.28)",
              backdropFilter: "blur(4px)",
            },
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 32px)", sm: 520 },
            maxWidth: 520,
            maxHeight: "78vh",
          }}
        >
          <Paper
            sx={{
              borderRadius: "24px",
              background: "var(--dashboard-panel-bg)",
              border: `3px solid ${dashboardPalette.panelBorder}`,
              boxShadow: "0 8px 0 rgba(62, 80, 147, 0.42)",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                background: "var(--dashboard-yellow)",
                color: "var(--dashboard-header-blue)",
                borderBottom: `3px solid ${dashboardPalette.accentYellowDark}`,
                px: 2.5,
                py: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Typography
                className="outlined-title-underlined"
                sx={{
                  fontWeight: 900,
                  fontSize: "1.65rem",
                  lineHeight: 1,
                }}
              >
                Notificaciones
              </Typography>
              <Chip
                label={`${GetNotif()} nuevas`}
                sx={{
                  background: "rgba(255,255,255,0.72)",
                  color: "var(--dashboard-header-blue)",
                  border: `2px solid ${dashboardPalette.accentYellowDark}`,
                  fontWeight: 800,
                }}
              />
            </Box>

            <Box
              sx={{
                p: 2,
                maxHeight: "calc(78vh - 88px)",
                overflowY: "auto",
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.65) 0%, rgba(236,240,248,0.82) 100%)",
                "&::-webkit-scrollbar": {
                  width: 10,
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(110, 131, 203, 0.4)",
                  borderRadius: "999px",
                },
              }}
            >
              {unreadNotifications.length === 0 ? (
                <Box
                  sx={{
                    minHeight: 220,
                    borderRadius: "18px",
                    border: `2px dashed ${dashboardPalette.panelBorder}`,
                    background: "rgba(255,255,255,0.72)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    px: 3,
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "var(--dashboard-yellow)",
                      border: `3px solid ${dashboardPalette.accentYellowDark}`,
                      color: "var(--dashboard-header-blue)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 0 rgba(211, 158, 0, 0.85)",
                    }}
                  >
                    <Notifications sx={{ fontSize: 28 }} />
                  </Box>
                  <Typography
                    sx={{
                      color: "var(--dashboard-header-blue)",
                      fontWeight: 900,
                      fontSize: "1.1rem",
                    }}
                  >
                    No tienes notificaciones pendientes
                  </Typography>
                  <Typography
                    sx={{ color: "var(--dashboard-text)", maxWidth: 280 }}
                  >
                    Cuando haya novedades o actividades nuevas, aparecerán aquí.
                  </Typography>
                </Box>
              ) : (
                <List
                  sx={{
                    p: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.25,
                  }}
                >
                  {unreadNotifications.map((notif, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        p: 1.5,
                        alignItems: "flex-start",
                        borderRadius: "18px",
                        background: "rgba(255,255,255,0.88)",
                        border: `2px solid ${dashboardPalette.panelBorder}`,
                        boxShadow: "0 4px 0 rgba(62, 80, 147, 0.18)",
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 0, mr: 1.5, mt: 0.25 }}>
                        <Box
                          sx={{
                            width: 42,
                            height: 42,
                            borderRadius: "50%",
                            background: "var(--dashboard-yellow)",
                            border: `2px solid ${dashboardPalette.accentYellowDark}`,
                            color: "var(--dashboard-header-blue)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 3px 0 rgba(211, 158, 0, 0.72)",
                            overflow: "hidden",
                          }}
                        >
                          {renderLooseNode(
                            notif.Icon,
                            <Notifications fontSize="small" />,
                          )}
                        </Box>
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              color: "var(--dashboard-header-blue)",
                              fontWeight: 800,
                              mb: 0.4,
                              lineHeight: 1.2,
                            }}
                          >
                            {notif.Title}
                          </Typography>
                        }
                        secondary={
                          <Typography
                            sx={{
                              color: "var(--dashboard-text)",
                              lineHeight: 1.35,
                            }}
                          >
                            {notif.Description}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Paper>
        </Box>
      </Modal>
    </AppBar>
  );
};

export default Navbar;
